import { type } from 'ramda';
import { preparePathWithParams } from '../../utils/paths';
import { evaluateCondition } from './evaluateCondition';

export const evaluateStep = (direction, current = {}, props = {}) => {
  if (!['back', 'next'].includes(direction)) {
    throw new Error(`Unsupported direction ${direction}`);
  }
  const stepIn = current[direction];
  if (!stepIn && stepIn !== '') {
    return false;
  }

  if (type(stepIn) === 'String') {
    return stepIn;
  }

  let step;
  if (type(stepIn) === 'Object') {
    step = stepIn;
  } else if (type(stepIn) === 'Array') {
    step = stepIn.find(({ condition }) => evaluateCondition(condition, props));
  }

  if (step) {
    const finalParams = {};
    if (step.params) {
      Object.keys(step.params).forEach(key => {
        finalParams[key] = props[step.params[key]];
      });
    }

    const result = preparePathWithParams(step.path, finalParams);
    if (result) {
      return result;
    }
  }

  console.warn(`Failed to evaluate ${direction} from current step ${current.id}`);
  return false;
};
